import { Box, Chip, TextField, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

import { addSynonym } from '../../utils/addSynonym';

// TODO: cleanup with cp_annotation_createproject_agent ff

interface SynonymsInputProps {
  id: string;
  synonyms: string[];
  onChange: (synonyms: string[]) => void;
}

export const SynonymsInput = ({ id, synonyms, onChange }: SynonymsInputProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [input, setInput] = useState('');

  const handleAdd = () => {
    const next = addSynonym(synonyms, input);
    if (next !== synonyms) onChange(next);
    setInput('');
  };

  const labelId = `${id}-label`;

  return (
    <Box>
      <Typography id={labelId} variant="subtitle2" sx={{ mb: theme.spacing(2) }}>
        {formatMessage({
          id: 'createProjectWizard.step.annotationAgent.concept.field.synonyms.draft',
        })}
      </Typography>
      <Box sx={{ display: 'flex', gap: theme.spacing(2) }}>
        <TextField
          id={`${id}-input`}
          fullWidth
          size="small"
          placeholder={formatMessage({
            id: 'createProjectWizard.step.annotationAgent.concept.synonyms.placeholder',
          })}
          inputProps={{ 'aria-labelledby': labelId }}
          value={input}
          onChange={(event) => setInput(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              // Enter would otherwise submit the wizard.
              event.preventDefault();
              handleAdd();
            }
          }}
        />
        <Button
          id={`${id}-add-button`}
          variant="outlined"
          startIcon="add"
          displayLabel={formatMessage({
            id: 'createProjectWizard.step.annotationAgent.concept.synonyms.add',
          })}
          onClickHandler={handleAdd}
          sx={{ textTransform: 'none' }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: theme.spacing(2), mt: theme.spacing(2) }}>
        {synonyms.map((synonym) => (
          <Chip
            key={synonym}
            label={synonym}
            size="small"
            onDelete={() => onChange(synonyms.filter((item) => item !== synonym))}
          />
        ))}
      </Box>
    </Box>
  );
};
